const $doc = $(document);

/**
 * Add cart item(s)
 * @return {Void}
 */

$doc.on('click', '.js-ajax-add', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this
    .closest('form')
    .find('select[name="id"]')
    .val();
  const quantity = $this
    .closest('form')
    .find('input[name="quantity"]')
    .val();
  const items = [{ id, quantity }];

  $this.addClass('btn--loading');

  Cart.add(items);
});

/**
 * Update item
 * @return {Void}
 */

$doc.on('change', '.js-line-item-quantity', function(event) {
  const $this = $(this);
  const quantity = $this.val();
  const id = $this.data('key');
  const isCartItem = $this.closest('.js-cart-item').length;
  let isCartPage = isCartItem ? true : false;

  Cart.updateItem(quantity, id, {}, isCartPage);
});

/**
 * Remove item
 * @return {Void}
 */

$doc.on('click', '.js-line-item-remove', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.data('key');
  const isCartItem = $this.closest('.js-cart-item').length;
  let isCartPage = isCartItem ? true : false;

  Cart.updateItem(0, id, null, isCartPage);
});
